import appEventData from "./appEventData";

type ErrorMessageEvent = {
  formFieldError: string;
  processStepLabel: string;
  processStepValue: string;
};

const errorMessageEvent = (errorMessageEvent: ErrorMessageEvent) => {
  appEventData.push({
    event: "Error Message Presented",
    formFieldError: errorMessageEvent.formFieldError,
    process: {
      processStepLabel: errorMessageEvent.processStepLabel,
      processStepValue: errorMessageEvent.processStepValue,
    },
  });
};

export default errorMessageEvent;
